(() => {
  const sections = Array.from(document.querySelectorAll('[data-mt-review-stack]'));
  if (!sections.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function update(section) {
    if (reduceMotion.matches) {
      section.style.setProperty('--mt-review-progress', '1');
      return;
    }

    const rect = section.getBoundingClientRect();
    const viewport = window.innerHeight || document.documentElement.clientHeight;
    const travel = Math.max(rect.height - viewport, 1);
    const progress = clamp(-rect.top / travel, 0, 1);
    section.style.setProperty('--mt-review-progress', progress.toFixed(4));
  }

  let ticking = false;
  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      sections.forEach(update);
      ticking = false;
    });
  }

  sections.forEach(update);
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  reduceMotion.addEventListener?.('change', requestUpdate);
})();
